export default __webpack_public_path__ + "static/media/webbarrell.ccdce298.png";